<template>
  <div>
    <transition
      enter-active-class="ease-in-out duration-300"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="ease-in-out duration-300"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        role="button"
        class="bg-ontick-carbon-900 pointer-events-none fixed inset-0 z-30 bg-opacity-75"
        v-if="active"
      >
        <button
          class="pointer-events-auto absolute inset-0"
          style="z-index: -1"
          @click.self="$emit('close')"
        >
          <span class="sr-only"> Fechar </span>
        </button>
        <transition
          appear
          enter-active-class="transform ease-out duration-300"
          enter-class="opacity-0 translate-y-full"
          enter-to-class="opacity-100 translate-y-0"
          leave-active-class=" transform ease-out duration-300"
          leave-class="opacity-100 translate-y-0"
          leave-to-class="opacity-0 translate-y-full"
        >
          <div
            class="bg-ontick-graphite-500 pointer-events-auto absolute bottom-0 h-2/3 w-full overflow-hidden rounded-t-[32px] pb-16"
          >
            <div class="flex h-full flex-col justify-between px-4 py-10">
              <div class="flex flex-col gap-4">
                <p class="text-2xl font-bold">Parar este Best?</p>
                <div class="param-box">
                  <div
                    class="divide-ontick-steel-500 flex w-full items-center divide-x-2"
                  >
                    <dl>
                      <dt>Ativo</dt>
                      <dd>
                        {{ data.bo_symbol }}
                      </dd>
                    </dl>
                    <dl>
                      <dt>Multiplicador</dt>
                      <dd>{{ data.bo_multiplier }}x</dd>
                    </dl>
                    <dl>
                      <dt>Target</dt>
                      <dd>
                        {{ data.bo_target
                        }}{{ targetType(data.best_target_type) }}
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
              <button
                @click="stop(data)"
                :disabled="button_is_disabled"
                class="bg-ontick-red-600 btn-shadow text-ontick-carbon-900 flex w-full items-center justify-center rounded-lg py-3 text-xl font-semibold uppercase active:brightness-75"
              >
                <span> Parar </span>
              </button>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import stopBest from "../stop-best";
export default {
  mixins: [stopBest],

  props: {
    active: {
      type: Boolean,
    },
    data: {
      type: Object,
    },
  },

  methods: {
    targetType(best_target_type) {
      switch (best_target_type) {
        case "POINTS":
          return "p";
        case "PERCENT":
          return "%";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.gradient {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #202a37 69.82%);
}
.btn-shadow {
  box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.35);
}
.param-box {
  @apply bg-ontick-carbon-500 flex flex-col gap-2 rounded-2xl p-3;
}
.text-shadow {
  text-shadow: 0px 2px 1px rgba(0, 0, 0, 0.5);
  &-lg {
    text-shadow: 0px 3px 2px rgba(0, 0, 0, 0.5);
  }
}
.call-btn {
  @apply flex w-full items-center justify-center gap-2 rounded-xl py-3 filter active:brightness-75;
}
dl {
  @apply w-full px-3 first:pl-0 last:pr-0;
  dt {
    @apply text-xs text-gray-400;
  }
  // dd {
  //   @apply text-shadow;
  // }
}
</style>
